import { useBreakpointContext } from './chunk-VBKLISDI.js';
import { Breakpoints } from './chunk-XUHDFZZL.js';
import { isObject, isNil } from './chunk-U5R6ZXH3.js';

// src/responsive/useResponsiveValue.tsx
var ResponsiveKeys = [...Object.keys(Breakpoints), "base"];
function isResponsiveObject(obj) {
  if (!isObject(obj)) {
    return false;
  }
  return Object.keys(obj).every((key) => ResponsiveKeys.includes(key));
}
function parseResponsiveValue(value, matchedBreakpoints) {
  if (isResponsiveObject(value)) {
    for (let i = 0; i < matchedBreakpoints.length; i++) {
      const responsiveValue = value[matchedBreakpoints[i]];
      if (!isNil(responsiveValue)) {
        return responsiveValue;
      }
    }
    return value["base"];
  }
  return value;
}
function useResponsiveValue(value) {
  const { matchedBreakpoints } = useBreakpointContext();
  return parseResponsiveValue(value, matchedBreakpoints);
}

export { isResponsiveObject, parseResponsiveValue, useResponsiveValue };
